// Icons

import { PaperclipIcon } from "lucide-react";

// Styling
const AttachedFilesIcon = () => <PaperclipIcon className="color-current size-5 rotate-35" />;

export const AttachedFilesIndicator = ({ count }: { count: number }) => {
  return (
    <span className="relative ms-1 inline-block align-bottom leading-none">
      <AttachedFilesIcon />
      {count > 0 && (
        <span className="fs-10 no-select color-current absolute right-0 bottom-0.5 ms-0.25 block leading-none">
          {count}
        </span>
      )}
    </span>
  );
};
